import { isProductionEnvironment } from './environment';
import { logger } from './logger';

// Validate URL is from allowed domains
const isAllowedUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    return parsed.hostname === 'yourdaye.com' || parsed.hostname.endsWith('.yourdaye.com') || parsed.hostname === 'localhost';
  } catch {
    return false;
  }
};

// Validate branch name format (alphanumeric and hyphens only)
const isValidBranchName = (branch: string): boolean => /^[a-zA-Z0-9-]+$/.test(branch);

export default function getOmsUrl(): string {
  // Only allow runtime overrides in non-production
  if (!isProductionEnvironment() && typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);

    // Direct URL override: ?oms_url=https://custom-backend.com
    const urlOverride = urlParams.get('oms_url') || localStorage.getItem('daye_oms_url');
    if (urlOverride) {
      if (isAllowedUrl(urlOverride)) {
        return urlOverride;
      }
      logger.warn('Invalid OMS URL override ignored (must be yourdaye.com or localhost):', urlOverride);
    }

    // Branch shorthand: ?oms=pr-123 → https://pr-123.oms.staging.yourdaye.com
    const branchOverride = urlParams.get('oms') || localStorage.getItem('daye_oms_branch');
    if (branchOverride) {
      if (isValidBranchName(branchOverride)) {
        return `https://${branchOverride}.oms.staging.yourdaye.com`;
      }
      logger.warn('Invalid OMS branch name ignored (alphanumeric and hyphens only):', branchOverride);
    }
  }

  return process.env.GATSBY_OMS_API_ENDPOINT ?? 'https://api.orders.yourdaye.com';
}
